import React, { useState, useEffect } from "react";
import axios from "axios";
import Approved from "../../../assets/Icon/live.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import PromoFile from "../../SuperStar/PromoVideo/PromoFile";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const LivePromoVideo = () => {
  const [loading, setLoading] = useState(true);
  const [event, setEvents] = useState([]);
  const [live, setLive] = useState("");

  useEffect(() => {
    axios.get(`/api/admin/promoVideoLive`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.promoVideos);
      }
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    axios.get(`/api/admin/promoVideoCount`).then((res) => {
      if (res.status === 200) {
        setLive(res.data.liveTotal);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title={"Live Promo Video"} image={Approved} count={live} />
      {loading === true ? (
        <LoaderPost />
      ) : (
        <PromoFile
          data={event}
          urlLink={`/superstar-admin/promoVideo/details`}
        />
      )}
    </>
  );
};

export default LivePromoVideo;
